<template>
    <section class="page-dashbord-my-tickets mt-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <contact-form :inputs="sentTiket" :title="'تیکت جدید'" class="mb-4" :action="true" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <tickedList :title="'لیست تیکت ها'"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import contactForm from "cp/contact-form.vue";
import tickedList from "cp/dashboard-component/ticked-list.vue";

export default {
    name: 'page-dashbord-my-tickets',
    components: {
        contactForm,
        tickedList
    },
    data () {
        return {
            sentTiket: [
                {
                    type: 'input',
                    name: 'subject',
                    label: 'عنوان',
                    msg: 'فیلد عنوان نباید خالی باشد',
                    model: '',
                    star: true,
                    col: '6',
                    rule: 'required'

                },
                {
                    clear: true
                },
                {
                    type: 'textarea',
                    name: 'msg',
                    label: 'متن',
                    model: '',
                    msg: 'فیلد متن نباید خالی باشد',
                    col: '6',
                    star: true,
                    rule: 'required'
                },
            ],
        }
    }
}
</script>
<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-my-tickets {
  .box-clear;
}
</style>


// WEBPACK FOOTER //
// src/pages/dashboard/my-tickets.vue